import { useCallback, useRef, useState } from "react";
// src/hooks/useControllableState.ts
/**
* Controlled/uncontrolled state, à la Radix's `useControllableState`.
*
* - Controlled: never owns state; the parent must feed the new `prop` back.
* - `onChange` fires on every `setValue`, not deduped.
*/
const useControllableState = ({ prop, defaultProp, onChange }) => {
	const [uncontrolled, setUncontrolled] = useState(defaultProp);
	const isControlled = prop !== void 0;
	const value = prop !== void 0 ? prop : uncontrolled;
	const valueRef = useRef(value);
	valueRef.current = value;
	const onChangeRef = useRef(onChange);
	onChangeRef.current = onChange;
	return [value, useCallback((next) => {
		const nextValue = typeof next === "function" ? next(valueRef.current) : next;
		valueRef.current = nextValue;
		if (!isControlled) setUncontrolled(nextValue);
		onChangeRef.current?.(nextValue);
	}, [isControlled])];
};
export { useControllableState };

//# sourceMappingURL=useControllableState-BCvUOC6G.js.map